import { createGenericRequest } from './createGenericRequest'
import { getCachedAuthToken } from './getCachedAuthToken'

export const getZoomAndFocusRange = (baseURL: string | null) => {
    return createGenericRequest(baseURL, 'GET', {}, '/camera/zoom_focus_range')
}

export const getBrightnessRange = (baseURL: string | null) => {
    return createGenericRequest(baseURL, 'GET', {}, '/camera/brightness_range')
}

export const getZoomAndFocusValues = (baseURL: string | null) => {
    return createGenericRequest(baseURL, 'GET', {}, '/camera/zoom_focus')
}

export const setZoomAndFocusValuesRequest = (
    baseURL: string | null,
    values: { zoom?: number; focus?: number; autofocus?: boolean }
) => {
    return createGenericRequest(baseURL, 'POST', values, '/camera/zoom_focus')
}

export const autofocusRequest = (baseURL: string | null) => {
    return createGenericRequest(baseURL, 'POST', {}, '/camera/autofocus')
}

export const getBrightnessValue = (baseURL: string | null) => {
    return createGenericRequest(baseURL, 'GET', {}, '/camera/brightness')
}

export const setBrightnessRequest = (baseURL: string | null, value: number) => {
    return createGenericRequest(baseURL, 'POST', { brightness: value }, '/camera/brightness')
}

export const getBlackmask = (baseURL: string | null) => {
    return createGenericRequest(baseURL, 'GET', {}, '/camera/blackmask')
}

export const addBlackmaskRequest = (baseURL: string | null, blackmask: any) => {
    if (!blackmask) {
        blackmask = {
            coords: [
                [0.2, 0.2],
                [0.8, 0.2],
                [0.8, 0.8],
                [0.2, 0.8]
            ]
        }
    }
    return createGenericRequest(baseURL, 'POST', blackmask, '/camera/blackmask')
}

export const deleteBlackmask = (baseURL: string | null, id: number) => {
    return createGenericRequest(baseURL, 'DELETE', { id }, '/camera/blackmask')
}

export const editBlackmaskRequest = (baseURL: string | null, id: number, cordsObject: any) => {
    return createGenericRequest(baseURL, 'PUT', { id, ...cordsObject }, '/camera/blackmask')
}

export const getSupportedFunctionalitiesRequest = (baseURL: string | null) => {
    return createGenericRequest(baseURL, 'GET', {}, '/camera/features')
}

export const getBlackmaskStatus = (baseURL: string | null) => {
    return createGenericRequest(baseURL, 'GET', {}, '/camera/blackmask/enabled')
}

export const setBlackmaskStatus = (baseURL: string | null, enabled: boolean) => {
    return createGenericRequest(baseURL, 'POST', { enabled }, '/camera/blackmask/enabled')
}

export const getCurrentLiveViewSnapshot = (baseURL: string | null) => {
    return createGenericRequest(baseURL, 'GET', {}, '/camera/snapshot', true)
}

export const regionalAutofocusRequest = (baseURL: string | null, normalizedPoints: any) => {
    return createGenericRequest(baseURL, 'POST', { rect: normalizedPoints }, '/camera/regional_autofocus')
}
